import moment from 'moment';
import {addFormElements} from './reservationForm.js';
import expand from '../utilities/expand.js';

function Event(eventDesc, eventDuration, eventId, eventScheduledTime, eventTypeId, eventTypeName, reservationId, trackNo, eventHeatTypes) {

  this.eventId = eventId;
  this.eventDesc = eventDesc;
  this.eventDuration = eventDuration;
  this.eventScheduledTime = eventScheduledTime;
  this.eventTypeId = eventTypeId;
  this.eventTypeName = eventTypeName;
  this.reservationId = reservationId;
  this.trackNo = trackNo;
  this.eventHeatTypes = eventHeatTypes;

  this.eventRoundsIds = [];

}

Event.prototype.getEventIds = function(api) {
  return new Promise (function (resolve, reject) {

    if (this.eventId && this.reservationId) {
      //if event ids exist
      resolve({
        eventId: this.eventId,
        eventReservationId: this.eventReservationId
      });
    } else {
      //create event and res and get ids if don't exist
      EventReservation.createEventReservationOnApi(api)
        .then( newEventReservationId => {
          this.reservationId = newEventReservationId;
          return this.createEventOnApi(api);
        })
        .then( newEventId => {
          this.eventId = newEventId;
          resolve({
            eventId: this.eventId,
            eventReservationId: this.reservationId
          });
        })

    }
  }.bind(this))
}

Event.prototype.createEventOnApi = function(api) {
  return new Promise( function(resolve, reject) {

    let start = moment(this.eventScheduledTime);
    let end = moment(this.eventScheduledTime).add(parseInt(this.eventDuration, 10), 'm');

    let postEventString = api.base_url + 'events?key=' + api.api +
      '&eventDesc=TEST EVENT Online' +
      '&eventDuration=' + this.eventDuration +
      '&eventNotes=This is an online test event form Surge.' +
      '&eventScheduledTime=' + start.clone().format('YYYY-MM-DDTHH:mm:ss') +
      '&eventTheme=-16776961' + //want to set custom theme colour to distinguish online bookings
      '&eventTypeId=' + this.eventTypeId +
      '&eventTypeName=' + this.eventTypeName +
      '&reservationId=' + this.reservationId +
      '&totalRacers=0' +
      '&trackNo=' + this.trackNo

    fetch( postEventString, {method: 'POST'} )
      .then( response => {
        if( !response.ok ){
          throw Error(response.statusText);
        }
        return response;
      })
      .then( response =>
        response.json()
      )
      .then( newEventId => {
        this.eventId = newEventId;
        //create rounds
        return this.createEventRoundsOnApi( newEventId, api )
      })
      .then( eventRoundsIds => {
        this.eventRoundsIds = eventRoundsIds;
        resolve(this.eventId);
      })
      .catch( err => {
        reject(err);
      })

  }.bind(this))
}

Event.prototype.createEventRoundsOnApi = function( eventId, api ) {
  return new Promise(function(resolve, reject) {

    //console.log(this.eventHeatTypes);

    let eventRoundsIds = [];

    if( this.eventHeatTypes ){
      this.eventHeatTypes.forEach( function( heatType ){

        let eventRoundsPostString = api.base_url + 'eventRounds?key=' + api.api +
          '&eventId=' + eventId +
          '&cadetsPerHeat=' + heatType.cadetsPerHeat +
          '&heatDescription=' + heatType.description +
          '&heatsPerRacer=' + heatType.heatsPerRacer +
          '&heatTypeId=' + heatType.heatTypeId +
          '&racersPerHeat=' + heatType.racersPerHeat +
          '&roundNumber=' + heatType.roundNumber +
          '&roundWinBy=' + heatType.roundWinBy +
          '&proceedValue=' + heatType.proceedValue +
          '&proceedMethod=' + heatType.proceedMethod +
          '&lineUpType=' + heatType.lineUpType;

        //console.log(eventRoundsPostString);

        fetch( eventRoundsPostString, {method: 'POST'} )
          .then( response => {
            if( !response.ok ){
              throw Error(response.statusText);
            }
            return response;
          })
          .then( response =>
            response.json()
          )
          .then( eventRoundId => {
            //console.log(eventRoundId);
            eventRoundsIds.push( eventRoundId )
          })
          .catch( err => {
            console.log(err);
          })

        resolve( eventRoundsIds );

      })
    } else {
      resolve(null);
    }

  }.bind(this));
}

Event.prototype.setId = function(eventId, api){
  return new Promise( function( resolve, reject){
    if(!eventId){
      this.createEventOnApi( api )
        .then( newEventId => {
          this.eventId = newEventId;
          resolve( newEventId );
        })
    } else {
      this.eventId = eventId;
      resolve( eventId );
    }
  }.bind(this))
}

Event.prototype.removeEventOnApi = function ( api ) {
  return new Promise( function( resolve, reject ){
    console.info('Deleting Event ' + this.eventId);

    let deleteEventString = api.base_url + 'events/' + this.eventId + '?key=' + api.api;

    fetch( deleteEventString, {method: 'DELETE'} )
      .then( response => api.checkResponse(response) )
      .then( response => {
        resolve( true )
      })
      .catch( err => {
        reject( err )
      })


  }.bind(this))
};


export default Event;
